import { useCallback, useEffect } from 'react'

import {
  getReceptionDevice,
  useGetReceptionDevice,
} from '@reception-web/common/api/www'
import { generatePath, useNavigate } from 'react-router-dom'

import { ERROR_TYPE, PATH } from '../../constants'
import { useDeviceIdProvider } from '../useDeviceIdProvider'

export function useSavedIdentifier() {
  const { deviceId, getRoute, setDeviceId } = useDeviceIdProvider()
  const { data: receptionDevice, error } = useGetReceptionDevice(deviceId ?? '')
  const navigate = useNavigate()

  const navigateToMaintenance = useCallback(() => {
    navigate(getRoute(PATH.maintenance), {
      state: {
        error: ERROR_TYPE.FAILED_TO_FETCH_DEVICE,
      },
    })
  }, [getRoute, navigate])

  useEffect(() => {
    // Save identifier when device is fetched
    if (receptionDevice && deviceId) {
      localStorage.setItem('identifier', deviceId)
    }
  }, [receptionDevice, deviceId])

  useEffect(() => {
    async function checkLocalStorageIdentifier() {
      const identifier = localStorage.getItem('identifier')

      if (!identifier) {
        navigateToMaintenance()
        return
      }

      try {
        const { data: device } = await getReceptionDevice(identifier)

        if (device) {
          // Set device id and navigate to root
          setDeviceId(identifier)
          navigate(generatePath(PATH.root, { deviceId: identifier }), {
            replace: true,
          })
          return
        }

        navigateToMaintenance()
      } catch (e) {
        navigateToMaintenance()
      }
    }

    if (error) {
      // Check localstorage identifier when failed to fetch device by route parameter
      checkLocalStorageIdentifier()
    }
  }, [error, getRoute, setDeviceId, navigate, navigateToMaintenance])

  return { receptionDevice }
}
